<template>
<div class="container">
    <h1>Send Push</h1>
    <div class="col my-4">
        <h2 class="message">To get a push, enter your guid.</h2>
        <p>
            <label class="message" for="phone">GUID</label>
            <input class="form-control"
                id="guid"
                v-model="guid"
                type="text"
                name="guid">
        </p>
    </div>
    <p>VIN MM987994136318764</p>
    <button class="btn btn-danger" v-on:click="sendPush">SEND PUSH</button>
    <div v-if={response}>{{response}}</div>
</div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'sendpush',
    data: function () {
        return {
            message: null,
            response:null,
            guid:null
        }
    },
    methods: {
        sendPush: function(){
            axios({
                "method": "POST",
                "url": "https://oneapi21mm.stg.telematicsct.com/v1/notification/alert",
                "headers": {
                    "guid": this.guid,
                    "x-api-key" : "FVDkNZAUvy7L5AvGDfFRX5CR98cHAnmo23ghM14 "
                },
                "data": {
                    "title": "SubscriptionExpired",
                    "message": "Subscription Expired. Please",
                    "oneapp_category": "sub_expired",
                    "oneapp_payload": {
                        "vin": "MM987994136318764",
                        "guid": this.guid,
                        "type": "silent",
                        "status": "active"
                    }
                }
            }).then((response) => this.response = response)
        }
    }
}
</script>

<style>

</style>
